<script>
import { Navigation, Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/svelte';
import {fade} from 'svelte/transition'
import "carbon-components-svelte/css/g90.css";
import {push, pop, replace} from 'svelte-spa-router'
import {Button, Form, TextInput, Select, SelectItem, Checkbox, DatePicker, DatePickerInput} from 'carbon-components-svelte';
import OtpInput from 'svelte-otp'
import {getUserData} from '../userdata.js'

import {Motion, M} from 'svelte-motion'
import { getAuth, signInWithPhoneNumber, RecaptchaVerifier } from "firebase/auth";
import {itemB} from './animations.js'
import Tailwindcss from '../Tailwind.svelte'
import {animateScroll} from 'svelte-scrollto-element'
import { registerUser } from '../auth';
import {getCountries}  from '../userdata'
import {auth} from '../firebase.js'
/* import {itemB} from './animations' */
import {sessionData} from '../stores'
import { onMount } from 'svelte';
import {_} from 'svelte-i18n'

import TelInput, { normalizedCountries } from 'svelte-tel-input';

  import {signInWithGoogle} from '../auth'
// Any Country Code Alpha-2 (ISO 3166)
let country = 'SE';
let selectedCountry = 'SE'

	// You must use E164 number format. It's guarantee the parsing and storing consistency.
let error = null;
let notifier


let session
let recap

let phone_number
let cresult


export let variants
export let container
export let animate

  sessionData.subscribe((data) => {
    session = data
  })


  onMount(() => {
      cresult = window.confirmationResult
    })

  async function handleOtp(otp){
      if(otp.detail.isInputComplete) {
            submitVerification(otp.detail.completevalue)
        }

    }

  async function submitVerification(code){

      try{
      const result = await cresult.confirm(code)
      const user = result.user;



        sessionData.update(d => {d.user = user; d.token = user.accessToken; return d})
        getUserData()



        }catch(e){

            error = true
          }



    }




</script>
<Tailwindcss/>


    <div transition:fade>
<M.div class="flex flex-col gap-y-10" initial="hidden" variants={container} {animate} >
<M.h1 variants={itemB} class="whitespace-pre-line min-w-max text-6xl" >{$_('gameplay.sentText')}</M.h1>
<M.h2 variants={itemB} class="min-w-max text-2xl" >{$_('gameplay.enterReceivedCode')}</M.h2>
  <M.div {variants}>
    <OtpInput on:notify={(e) => handleOtp(e)} customTextInputClass="text-5xl text-white bg-black border-2 border-white w-14 h-14 text-center" customWrapperClass="text-black flex flex-row gap-x-4 font-autoscape" separator=" " numberOfInputs={6} />

    </M.div>

{#if error}
<M.h2 {variants} class="text-red min-w-max text-xl" >{$_('gameplay.wrongCode')}</M.h2>
{/if}
</M.div>
</div>

<style>
</style>
